/**
 * Check for a logout trigger when performing any Ajax request
 *
 * @author Drake Parker
 * @version 04/14/2015
 *
 * The script inc/logout.php runs in any script that includes setup.php.  That script checks for 'ajax' in $_REQUEST
 * and, if found and if the user's session has expired, prints a JSON response of { logout: true }.  In that case, our
 * `dataFilter` hook forces a logout on the parent page by reloading the page.  Otherwise, `dataFilter` simply passes
 * the response unaltered to any `success` hooks in the ajax call.
 */

$.ajaxSetup({
    data: {
        ajax: true
    },
    dataFilter: function(response) {
        try {
            data = JSON.parse(response);
            if(data.logout) {
                location.reload();
                return { status: 'error' };
            }

            // If permission is denied for the ajax call, then add error message and scroll to the top of the page
            if(data.permissionDenied){
                $('#dynamicErrors').append(
                    $('<li>').append(data.message)
                );

                $('#dynamicErrorsContainer').show();
                window.scrollTo(0, 0);

                return '';
            }


        } catch(e) {
            // it's html or xml, carry on
        }
        return response;
    }
});

/*!
 * jQuery serializeObject - v0.2 - 1/20/2010
 * http://benalman.com/projects/jquery-misc-plugins/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Whereas .serializeArray() serializes a form into an array, .serializeObject()
// serializes a form into an (arguably more useful) object.

(function($,undefined){
  '$:nomunge'; // Used by YUI compressor.
  
  $.fn.serializeObject = function(){
    var obj = {};
    
    $.each( this.serializeArray(), function(i,o){
      var n = o.name,
        v = o.value;
        
        obj[n] = obj[n] === undefined ? v
          : $.isArray( obj[n] ) ? obj[n].concat( v )
          : [ obj[n], v ];
    });
    
    return obj;
  };
  
})(jQuery);